import React, { useContext, useRef } from "react";
import "./WeekFilter.css";
import { FilterGroup, FilterLayoutContext } from "../FilterBar";
import { sameWeeks, toggleWeek } from "../nflToolFilters";

export default function WeekFilter({ weeks, playedThrough, selected, onChange }) {
  const layout = useContext(FilterLayoutContext);
  const anchorRef = useRef(null);
  const played = weeks.filter((week) => week <= playedThrough);
  const lastThree = played.slice(-3);

  function handleClick(week, event) {
    const next = toggleWeek(selected, week, {
      anchor: event.shiftKey ? anchorRef.current : null,
    });
    anchorRef.current = week;
    onChange(next);
  }

  const presets = (
    <span className="nfl-week-presets">
      <button
        type="button"
        className="nfl-link-button"
        aria-pressed={sameWeeks(selected, lastThree)}
        onClick={() => onChange(lastThree)}
      >
        Last 3
      </button>
      <button
        type="button"
        className="nfl-link-button"
        aria-pressed={sameWeeks(selected, played)}
        onClick={() => onChange(played)}
      >
        Season
      </button>
    </span>
  );

  const isSheet = layout === "sheet";

  return (
    <FilterGroup label="Weeks" hint={isSheet ? presets : null}>
      <div className={isSheet ? "nfl-week-grid" : "nfl-week-track"}>
        {weeks.map((week) => {
          const isOn = selected.includes(week);
          const classes = ["nfl-week"];
          if (isOn) {
            classes.push("is-on");
            if (!selected.includes(week - 1)) {
              classes.push("is-start");
            }
            if (!selected.includes(week + 1)) {
              classes.push("is-end");
            }
          }
          return (
            <button
              key={week}
              type="button"
              className={classes.join(" ")}
              aria-pressed={isOn}
              aria-label={`Week ${week}`}
              disabled={week > playedThrough}
              onClick={(event) => handleClick(week, event)}
            >
              {week}
            </button>
          );
        })}
      </div>
      {isSheet ? null : presets}
    </FilterGroup>
  );
}
